var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{staticClass:"rights-statement-button attribution",attrs:{"destination":_vm.rightsStatement,"data-qa":"rights statement","hide-external-icon":""}},[_c('RightsStatement',{attrs:{"rights-statement-url":_vm.rightsStatement}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }